export default "__VITE_ASSET__CgHR7meG__"